module.exports = __webpack_public_path__ + "img/banner-standard.400ea343.jpg";